import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { Subscription } from 'rxjs';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';

@Component({
  selector: 'app-events-new-event-dashboard',
  templateUrl: './events-new-event-dashboard.component.html',
  styleUrls: ['./events-new-event-dashboard.component.scss']
})
export class EventsNewEventDashboardComponent implements OnInit, OnDestroy {

  alert;
  centerList;
  getAlertInfoSubscription: Subscription;

  constructor(private userStorageService: UserStorageService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.centerList = this.userStorageService.getCenterList();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-exclamation-circle', 'events-page.new event', 'account/events', [new BRoute('account-page.account', 'account'), new BRoute('events-page.events', 'account/events'), new BRoute('events-page.new event')]));
  }

  ngOnDestroy() {
    if (this.getAlertInfoSubscription) { this.getAlertInfoSubscription.unsubscribe(); }

  }
}
